import { API_KEY } from "../constants";

// Assuming you have a function to fetch the image data
export const fetchImage = async (url) => {
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${API_KEY}`,
    },
  });
  const blob = await response.blob();
  return URL.createObjectURL(blob);
};
